export const BRIA_USER_ASSETS = "bria-user-assets";
export const BRIA_QUALCOMM_SERVER_HOST = "http://localhost:8000";
